// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../@nuxt/postcss8/node_modules/css-loader/dist/cjs.js??ref--7-oneOf-1-1!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../@nuxt/postcss8/node_modules/postcss-loader/dist/cjs.js??ref--7-oneOf-1-2!../../../sass-loader/dist/cjs.js??ref--7-oneOf-1-3!../../../vue-loader/lib/index.js??vue-loader-options!./clipper-basic.vue?vue&type=style&index=0&id=45869ad8&lang=scss&scoped=true&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("59353ad7", content, true, {"sourceMap":false});